import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createClient } from "../../../redux/actions/auth";
import { ablToken, authanticatedUser, radomCharactors } from "../../../utils/helper";
// import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

export default function CreateClientModal({ options }) {
  const diapatch = useDispatch();
  const [clientNumber, setClientNumber] = useState('')
  const { openCreateClientModal, setOpenCreateClientModal } = options;
  const { loading } = useSelector((state) => state.users);

  const toggleCreateClient = async () => {
    setOpenCreateClientModal(false);
    // return <Navigate replace to="/login" />;
  };


  const createNewClient = () => {
    const tmpData = {
      clientNumber,
      ablToken, 
      token: authanticatedUser.token
    }
    diapatch(createClient(tmpData))
    setClientNumber('');
    toggleCreateClient()
  }

  return (
    <Dialog
      open={openCreateClientModal}
      onClose={setOpenCreateClientModal}
      className="relative z-20"
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 grid-cols-2 gap-4">
              <DialogTitle
                as="h3"
                className="text-lg mb-5 font-bold text-gray-900"
              >
                Create Client
              </DialogTitle>

              <div className="col-span-1">
                <label
                  htmlFor="clientNumber"
                  className="block text-sm font-bold text-gray-900"
                >
                  Client Number
                </label>
                <div className="mt-2">
                  <input
                    id="clientNumber"
                    name="clientNumber"
                    type="text"
                    value={clientNumber}
                    autoComplete="Client Number"
                    onChange={e => setClientNumber(e.target.value)}
                    className="block pl-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </div>
              </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
              <button
                type="button"
                onClick={createNewClient}
                disabled={authanticatedUser?.accessModules[0].rights?.includes('create') ? false : true}
                className="inline-flex w-full justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 sm:ml-3 sm:w-auto"
              >
               {loading ? 'Loading...': 'Add Client'} 
              </button>
              <button
                type="button"
                data-autofocus
                onClick={() => setOpenCreateClientModal(false)}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
              >
                Cancel
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
